import { useCallback } from 'react';
import { useAircraftManagement } from './useAircraftManagement';
import { useAppSelector } from '../../store/hooks';
import toast from 'react-hot-toast';

/**
 * Hook to check if user has any aircraft
 * Fetches aircraft data if not already loaded
 * Shows toast if no aircraft found
 * @returns {Object} - { hasAircraft, checkAircraft, loading }
 */
export const useAircraftCheck = () => {
  const { aircraft, loadAircraft, loading } = useAircraftManagement();
  const user = useAppSelector((state) => state.auth.user);

  const hasAircraft = aircraft && aircraft.length > 0;

  const checkAircraft = useCallback(async () => {
    try {
      // If aircraft already loaded and present, return immediately
      if (aircraft && aircraft.length > 0) {
        return true;
      }

      // Fetch from server and use the returned data directly
      if (user?.id) {
        const action = await loadAircraft({
          userId: user.id,
          page: 1,
          limit: 100
        });

        // unwrap the Redux action payload to get the actual aircraft list
        const payload = action?.payload;
        const fetchedAircraft = payload?.data || payload || [];
        const count = Array.isArray(fetchedAircraft) ? fetchedAircraft.length : 0;

        if (count === 0) {
          toast.error('You DO NOT have any aircraft added. Please add an Aircraft before continuing');
          return false;
        }
        return true;
      }

      toast.error('You DO NOT have any aircraft added. Please add an Aircraft before continuing');
      return false;
    } catch (error) {
      toast.error('Failed to check aircraft');
      return false;
    }
  }, [aircraft, user?.id, loadAircraft]);

  return {
    hasAircraft,
    checkAircraft,
    loading
  };
};

export default useAircraftCheck;
